<template>
  <v-container fill-height fluid style="overflow=hidden">
    <div v-if="FinancialAidApplication.status === 'created'">
      <v-container grid-list-lg fluid v-if="Business">
        <div v-if="$vuetify.breakpoint.xsOnly">
          <div class="text-center mt-4">
            <img v-if="Business.imageUrl" height="50" :src="Business.imageUrl" alt="Logo" />

            <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
            <div v-if="Business.phoneNumber">
              {{ Business.phoneNumber | USPhoneNumber }}
            </div>
            <div>
              <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
              }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
              <span v-if="Business.zip">{{ Business.zip }}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
            <v-flex shrink>
              <img v-if="Business.imageUrl" height="100" :src="Business.imageUrl" alt="Logo" />
            </v-flex>
            <v-flex shrink>
              <div>
                <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
                <div>
                  <span v-if="Business.address">{{ Business.address }}</span>, <span v-if="Business.city">{{ Business.city
                  }}</span>, <span v-if="Business.state">{{ Business.state }}</span>
                  <span v-if="Business.zip">{{ Business.zip }}</span>
                </div>
                <div v-if="Business.phoneNumber">
                  {{ Business.phoneNumber | USPhoneNumber }}
                </div>
              </div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <div class="text-right">
                <div class="text-h5">Financial Aid Application</div>
                <div> For Zakat / Sadqa & Fatrah</div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
      <v-container grid-list-lg fluid>
        <v-flex shrink>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Your Information</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.fullName" label="Full Name"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select dense outlined :items="genderItems" v-model="FinancialAidApplication.gender"
                    label="Gender" hide-details></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.phoneNumber" label="Contact Number"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.dob" label="Date Of Birth"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.email" label="Email"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.address" label="Address"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select dense outlined :items="maritalStatusItems" v-model="FinancialAidApplication.maritalStatus"
                    label="Marital Status" hide-details></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.legalStatus" label="Legal Status"></v-text-field>
                </v-flex>
              </v-layout>
              <v-flex>
                <v-layout row wrap align-center>
                  <v-flex>
                    Driver License
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs12 md3>
                    <v-card height="150" color="grey lighten-4" @click="pickFile" hover outlined>
                      <v-layout v-if="!FinancialAidApplication.license" align-center="align-center" justify-center="justify-center"
                        column="column" fill-height="fill-height">
                        <v-flex shrink>
                          <img height="50"
                            src="data:image/svg+xml;utf8;base64,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" />
                        </v-flex>
                        <v-flex shrink>
                          <div class="text-center">Dimension: 1024 x 400 (px)</div>
                        </v-flex>
                      </v-layout>



                      <img height="150" :src="FinancialAidApplication.license" v-if="FinancialAidApplication.license" />
                    </v-card>
                    <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
                  </v-flex>

                </v-layout>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex shrink>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Employment & Income Details</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-select dense outlined :items="jobStatusItems" v-model="FinancialAidApplication.jobStatus"
                    label="Job Status" hide-details></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.salary" label="Monthly Salary"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field outlined autofocus hide-details dense
                    v-model="FinancialAidApplication.otherIncome" label="Other Income"></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex shrink>
          <v-card outlined>
            <v-toolbar dense flat color="grey lighten-3">
              <v-toolbar-title>Financial Aid</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-layout column>
                <v-flex>
                  <v-layout row wrap align-center>
                    <v-flex xs12 md8>
                      <p>Which of the following do you believe you are eligible for</p>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs12 md2>
                      <v-select dense outlined :items="eligibleForItems" v-model="FinancialAidApplication.eligibleFor"
                        label="Financial Aid" hide-details></v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-container>
      <v-divider></v-divider>
      <v-card tile flat>
        <v-card-actions>
          <v-spacer> </v-spacer>
          <v-btn color="primary" dark @click="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </div>
      <LinkExpiredPage v-else/>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import financialAidApplicationService from "../service.js";
import applicationService from "@/modules/Application/service.js";
import LinkExpiredPage from "@/modules/SadqaFinancialAid/view/LinkExpired.vue";

export default {
  name: "edit-FinancialAidApplication",
  data() {
    return {
      loading: false,
      Business: null,
      FinancialAidApplication: {
        fullName: null,
        phoneNumber: null,
        dob: null,
        email: null,
        address: null,
        legalStatus: null,
        maritalStatus: null,
        salary: null,
        otherIncome: null,
        jobStatus: null,
        eligibleFor: null,
        gender: null,
      },
      maritalStatusItems: ['married', 'saparated', 'widowed', 'divorced'],
      genderItems: ['male', 'female'],
      jobStatusItems: ['unemployed', 'partTime', 'fullTime'],
      eligibleForItems: ['zakaat', 'sadqah'],
    };
  },
  created() {
    if(!this.$route.params.id)
      this.$router.push({ name: "pagenotfound" });
    this.loadBusiness()
    this.loadData()
  },
  components: {
    LinkExpiredPage
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
  },
  methods: {
    loadBusiness() {
      let id = this.$route.params.id;
      applicationService
        .getBusinessInformation({ key: id })
        .then((response) => {
          console.log("respons bus ", response.data)
          this.Business = response.data;
        })
        .catch((error) => {
          console.log("error getting business", error);
          this.$router.push({ name: "pagenotfound" });
        });
    },
    onFilePicked(e) {
      const { files } = e.target;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf('.') <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          this.FinancialAidApplication.license = fr.result;
        });
      } else {
        this.imageName = '';
        this.FinancialAidApplication.image = '';
        this.FinancialAidApplication.license = '';
      }
    },
    pickFile() {
      this.$refs.image.click();
    },
    empty() {
      this.loading = false,
      this.Business = null,
      this.FinancialAidApplication = {
        fullName: null,
        phoneNumber: null,
        dob: null,
        email: null,
        address: null,
        legalStatus: null,
        maritalStatus: null,
        salary: null,
        otherIncome: null,
        jobStatus: null,
        eligibleFor: null,
      }
    },
    loadData(){
      const { id, code } = this.$route.params;
      return financialAidApplicationService.publicGetByCode(code, {key: id}).then((response) => {
        console.log("Loading data response ", response)
        this.FinancialAidApplication = response.data;
        return response;
      }).catch((error) => {
        console.log("error", error);
      });
    },
    submit() {
      this.loading = true;
      if(this.FinancialAidApplication.phoneNumber){
        this.FinancialAidApplication.phoneNumber = this.FinancialAidApplication.phoneNumber.replace(
          /[^a-zA-Z0-9]/g,
          ""
        );
      }
      let key = this.$route.params.id;
      this.FinancialAidApplication.status = 'pending'
      return financialAidApplicationService
        .publicUpdate(this.FinancialAidApplication.id, key, this.FinancialAidApplication)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "FinancialAidApplication is updated",
              });
            this.loading = false;
            this.loadData()
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
  },
};
</script>

<style scoped></style>
